/* eslint-disable jsx-a11y/alt-text */
import React from "react";
import Api from "../../../../services/ServiceApi";
import Cookies from "js-cookie";
import { Radio, Input } from "antd";

const content = {
  employment: {
    label: "การจ้าง / ไม่จ้าง : ",
    value: "",
    option: [
      { label: "จ้าง", value: "1" },
      { label: "ไม่จ้าง", value: "2" },
    ],
  },
  employmenttype: {
    label: "ประเภทการจ้าง : ",
    value: "",
    option: [
      { label: "จ้างเหมา", value: "1" },
      { label: "จ้างรายครั้ง", value: "2" },
    ],
  },
  reason: {
    label: "เหตุผลในการแก้ไข : ",
    value: "",
  },
};

export default function employment({
  title,
  formdata,
  valuechange,
  language,
  factupdate,
}) {
  const locale = Cookies.get("locale");
  return (
    <div
      className="col-lg-7 mt-4 pb-5 mr-4 ml-4"
      style={{ backgroundColor: "#FFFFFF", borderRadius: "5px" }}
    >
      <div className="row pr-5 mt-3">
        <img
          src={Api.absoluteUrl("/icon/employment.svg")}
          className="mr-2 mb-1"
        ></img>
        <span className="font-thai-b fs-22">{title}</span>
      </div>
      <div className="row mt-3">
        <div className="col-12">
          <div className="row">
            <div className="col-lg-4">
              <div className="row">
                <span className="font-thai-r fs-18 c-gray">
                  {factupdate
                    ? language[locale]["employment"]
                    : content.employment.label}
                </span>
              </div>
              <div className="row">
                <Radio.Group
                  disabled={formdata.IsHold || false}
                  name="employment"
                  value={String(formdata.employment)}
                  onChange={valuechange}
                >
                  {content.employment.option.map((data, index) => (
                    <Radio
                      key={`employmenttype_option_a_${index}`}
                      value={data.value}
                    >
                      <span className="fs-18 c-blue">{data.label}</span>
                    </Radio>
                  ))}
                </Radio.Group>
              </div>
            </div>
            <div className="col-lg-4">
              <div className="row">
                <span className="font-thai-r fs-18 c-gray">
                  {factupdate
                    ? language[locale]["employment_type"]
                    : content.employmenttype.label}
                </span>
              </div>
              <div className="row">
                <Radio.Group
                  disabled={formdata.IsHold || false}
                  name="employmenttype"
                  value={String(formdata.employmenttype)}
                  onChange={valuechange}
                >
                  {content.employmenttype.option.map((data, index) => (
                    <Radio
                      key={`employmenttype_option_b_${index}`}
                      value={data.value}
                    >
                      <span className="fs-18 c-blue">{data.label}</span>
                    </Radio>
                  ))}
                </Radio.Group>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-lg-10">
              <div className="row mt-2">
                <span className="font-thai-r fs-18 c-gray">
                  {factupdate
                    ? language[locale]["reason"]
                    : content.reason.label}
                </span>
              </div>
              <div className="row">
                <Input
                  disabled={formdata.IsHold || false}
                  name="employmentreson"
                  className="c-blue"
                  value={formdata.employmentreson}
                  onChange={valuechange}
                ></Input>
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* <div className="row d-flex justify-content-center">
        <div className="col-9 ml-5">
          <div className="row">
            <div className="col-lg-6">
              <div className="row">
                <span className="font-thai-r c-gray fs-18">
                  {factupdate
                    ? language[locale]["employment"]
                    : content.employment.label}
                </span>
              </div>
              <div className="row">
                <div className="col-5 font-thai-r">
                  <Radio.Group
                    name="employment"
                    value={String(formdata.employment)}
                    onChange={valuechange}
                  >
                    {content.employment.option.map((data, index) => (
                      <Radio
                        key={`employmenttype_option_a_${index}`}
                        value={data.value}
                      >
                        <span className="fs-18 c-blue">{data.label}</span>
                      </Radio>
                    ))}
                  </Radio.Group>
                </div>
              </div>
            </div>
            <div className="col-lg-6">
              <div className="row">
                <span className="font-thai-r c-gray fs-18">
                  {factupdate
                    ? language[locale]["employment_type"]
                    : content.employmenttype.label}
                </span>
              </div>
              <div className="row">
                <div className="col-5 font-thai-r">
                  <Radio.Group
                    name="employmenttype"
                    value={String(formdata.employmenttype)}
                    onChange={valuechange}
                  >
                    {content.employmenttype.option.map((data, index) => (
                      <Radio
                        key={`employmenttype_option_b_${index}`}
                        value={data.value}
                      >
                        <span className="fs-18 c-blue">{data.label}</span>
                      </Radio>
                    ))}
                  </Radio.Group>
                </div>
              </div>
            </div>
          </div>
          <div className="row">
            <div className="col-lg-6">
              <div className="row">
                <span className="font-thai-r c-gray fs-18">
                  {factupdate
                    ? language[locale]["reason"]
                    : content.reason.label}
                </span>
              </div>
              <div className="row">
                <div className="col-5 font-thai-r">
                  <Input
                    name="employmentreson"
                    className="c-blue"
                    value={formdata.employmentreson}
                    onChange={valuechange}
                  ></Input>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div> */}
    </div>
  );
}
